
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftRight50 as ObiThreewayAcuatorPistonInleftRight50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-right-50.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftRight50 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-right-50',
   elementClass: ObiThreewayAcuatorPistonInleftRight50Element,
   events: {
     
   }
  });
 
 